import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {HeatmapMainComponent} from "./components/main/heatmap-main.component";

const routes: Routes = [{
  path: '',
  component: HeatmapMainComponent,
}]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HeatmapRoutingModule {
}
